import Empty from '@/views/Empty';
import VehicleGroupList from '@/views/pages/vehicle_group/List';
import VehicleGroupCreateEdit from '@/views/pages/vehicle_group/CreateEdit';
import VehicleGroupDetail from '@/views/pages/vehicle_group/Detail';
import VehicleGroupPreview from '@/views/pages/vehicle_group/detail/Preview';
import AssignVehicle from '@/views/pages/vehicle_group/detail/AssignVehicle';


export default {
  path: 'vehicle_group',
  component: Empty,
  meta: {
    accessKey: 'MAIN.VEHICLE_GROUP.READ',
  },
  children: [
    {
      path: '',
      name: 'Vehicle Group List',
      component: VehicleGroupList,
    },
    {
      path: 'create',
      name: 'Create Vehicle',
      component: VehicleGroupCreateEdit,
    },
    {
      path: ':vehicleGroupId',
      component: VehicleGroupDetail,
      children: [
        {
          path: '',
          name: 'Vehicle Group Preview',
          component: VehicleGroupPreview,
        },
        {
          path: 'assign_vehicle',
          name: 'Assign Vehicle',
          component: AssignVehicle,
        },
      ],
    },
    {
      path: ':vehicleGroupId/edit',
      component: VehicleGroupCreateEdit,
      name: 'Edit Vehicle Group',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/vehicle_group.js